/**
 * Summary Controller
 */
(function(angular) {
    'use strict';

    var app = angular.module('asDemandMgr');
    var generateImpsGoalChart;
    var generateClicksGoalChart;
    var generateCompletesChart;
    var generateCtrChart;
    var generateVctrChart;

    app.controller('SummaryController', [
        '$scope',
        'campaignApi',
        'optionsApi',
        '$location',
        function($scope, campaignApi, optionsApi, $location) {
            $scope.campaignsData = [];
            $scope.summaryData = [];
            $scope.summaryCreativesData = [];
            $scope.dailyData = [];
            $scope.summaryDailyData = [];
            $scope.showSummary = true;
            $scope.showSelectedCreatives = true;
            $scope.showDaily = true;
            $scope.showDailySummary = true;
            $scope.showImpsGoalChart = true;
            $scope.showClicksGoalChart = true;
            $scope.showCompletesChart = true;
            $scope.showCtrChart = true;
            $scope.showVctrChart = true;
            $scope.loadingSummary = true;
            $scope.loadingSummaryCreatives = false;
            $scope.loadingDaily = true;
            $scope.isDebug = $location.search().debug !== undefined && $location.search().debug === '1';
            $scope.allCreatives = allCreativesOptions;
            $scope.selectedCreatives = preselectedAids;

            $scope.$watch('selectedCreatives', function(newValue, oldValue) {
                fetchCreativesData();
            }, true);



            var yyyymmdd = function (x) {
                var y = x.getFullYear().toString();
                var m = (x.getMonth() + 1).toString();
                var d = x.getDate().toString();
                (d.length == 1) && (d = '0' + d);
                (m.length == 1) && (m = '0' + m);
                var yyyymmdd = y + m + d;
                return yyyymmdd;
            };

            var fetchCreativesData = function () {
                console.log("fetchCreativesData", $scope.selectedCreatives, start_date, end_date);
                $scope.loadingSummaryCreatives = true;
                if ($scope.selectedCreatives) {
                    campaignApi.getSummaryCreativesData($scope.selectedCreatives, start_date, end_date)
                        .then(
                            function (res) {
                                $scope.summaryCreativesData = [];
                                if (res.length > 0) {
                                    $scope.summaryCreativesData = res;
                                }
                                $scope.loadingSummaryCreatives = false;
                            },
                            function () {
                                console.error('Error while fetching data');
                                $scope.loadingSummaryCreatives = false;
                            }
                        );
                }
            };
            var fetchData = function () {
            console.log(preselectedCids, start_date, end_date);
            campaignApi.getSummaryData(preselectedCids, start_date, end_date)
                .then(
                    function (res) {
                        $scope.summaryData = [];
                        if (res.length > 0) {
                            $scope.summaryData = res;
                        }
                        $scope.loadingSummary = false;
                    },
                    function () {
                        console.error('Error while fetching data');
                        $scope.loadingSummary = false;
                    }
                );


               campaignApi.getSummaryDailyData(preselectedCids, start_date, end_date)
                    .then(
                        function (res) {
                            $scope.dailyData = [];
                            $scope.summaryDailyData = [];
                            let tempSummaryDailyData = [];
                            let chartData = {merged_imps: [], merged_imps_goal: [], merged_clicks: [], merged_clicks_goal: [], merged_completes: [], ctr: [], vctr: []};
                            let dateRange = [];

                            for (var date in res) {
                                tempSummaryDailyData[date] = {
                                    cids: [],
                                    date: date,
                                    merged_imps: 0,
                                    merged_clicks: 0,
                                    merged_completes: 0,
                                    ctr: 0,
                                    vctr: 0,
                                    merged_imps_goal: 0,
                                    merged_clicks_goal: 0,
                                    merged_diff_imps: 0,
                                    merged_diff_clicks: 0,
                                    rel_diff_imps: 0,
                                    rel_diff_clicks: 0
                                };
                                
                                dateRange.push(date);
                                
                                for (var cid in res[date]) {
                                    $scope.dailyData.push(res[date][cid]);
                                    
                                    

                                    tempSummaryDailyData[date].cids.push(cid);
                                    tempSummaryDailyData[date].merged_imps += res[date][cid].n_imps;
                                    tempSummaryDailyData[date].merged_clicks += res[date][cid].n_clicks;
                                    tempSummaryDailyData[date].merged_completes += res[date][cid].n_completes;

                                    tempSummaryDailyData[date].merged_imps_goal += res[date][cid].n_imps_goal;
                                    tempSummaryDailyData[date].merged_clicks_goal += res[date][cid].n_clicks_goal;
                                    tempSummaryDailyData[date].merged_diff_imps += res[date][cid].diff_imps;
                                    tempSummaryDailyData[date].merged_diff_clicks += res[date][cid].diff_clicks;
                                }
                                //postcalc ops
                                tempSummaryDailyData[date].cids = tempSummaryDailyData[date].cids.join(",");
                                tempSummaryDailyData[date].ctr = tempSummaryDailyData[date].merged_imps > 0 ?  tempSummaryDailyData[date].merged_clicks / tempSummaryDailyData[date].merged_imps * 100.0 : 0;
                                tempSummaryDailyData[date].vctr = tempSummaryDailyData[date].merged_imps > 0 ? tempSummaryDailyData[date].merged_completes  / tempSummaryDailyData[date].merged_imps * 100.0 : 0;
                                tempSummaryDailyData[date].rel_diff_imps = tempSummaryDailyData[date].merged_imps_goal > 0 ? tempSummaryDailyData[date].merged_diff_imps / tempSummaryDailyData[date].merged_imps_goal * 100 : 0 ;
                                tempSummaryDailyData[date].rel_diff_clicks = tempSummaryDailyData[date].merged_imps_goal > 0 ? tempSummaryDailyData[date].merged_diff_clicks / tempSummaryDailyData[date].merged_clicks_goal * 100 : 0 ;
                                
                                chartData.merged_imps.push(tempSummaryDailyData[date].merged_imps);
                                chartData.merged_imps_goal.push(tempSummaryDailyData[date].merged_imps_goal);
                                chartData.merged_clicks.push(tempSummaryDailyData[date].merged_clicks);
                                chartData.merged_clicks_goal.push(tempSummaryDailyData[date].merged_clicks_goal);
                                chartData.merged_completes.push(tempSummaryDailyData[date].merged_completes);
                                chartData.ctr.push(tempSummaryDailyData[date].ctr);
                                chartData.vctr.push(tempSummaryDailyData[date].vctr);
                            }

                            // fill summaryDailyData
                            for (var date in tempSummaryDailyData) {
                                $scope.summaryDailyData.push(tempSummaryDailyData[date]);
                            }
                            console.log($scope.summaryDailyData);
                            generateImpsGoalChart(dateRange, chartData);
                            generateClicksGoalChart(dateRange, chartData);
                            generateCompletesChart(dateRange, chartData);
                            generateCtrChart(dateRange, chartData);
                            generateVctrChart(dateRange, chartData);
                            $scope.loadingDaily = false;
                        },
                        function () {
                            console.error('Error while fetching data');
                            $scope.loadingDaily = false;
                        }
                    );

            };

            fetchData();
        }
    ]);

    generateImpsGoalChart = function(categories, data) {
        Highcharts.chart('imps-goal-container', {
            exporting: { enabled: false },
            credits: { enabled: false },
            chart: {
                type: 'column',
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,

                height: '250px',
            },
            title: {
                text: null,
            },
            xAxis: {
                categories: categories,
            },
            yAxis: [
                {
                    title: {
                        text: 'Impressions / Impressions Goals',
                    },                    
                },              
            ],                      
            
            legend: {
                enabled: true,
            },            

            series: [
                {
                    name: 'Imressions',
                    type: 'column',
                    data: data.merged_imps,
                    
                    tooltip: {
                        valueDecimals: 0,
                    }
                },    
                {
                    name: 'ImressionsGoals',
                    type: 'spline',
                    data: data.merged_imps_goal,  
                    
                    tooltip: {
                        valueDecimals: 0,
                    }
                },  
            ],            
        });
    };    
    
    generateClicksGoalChart = function(categories, data) {
        Highcharts.chart('clicks-goal-container', {
            exporting: { enabled: false },
            credits: { enabled: false },
            chart: {
                type: 'column',
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,

                height: '250px',
            },
            title: {
                text: null,
            },
            xAxis: {
                categories: categories,
            },
            yAxis: [
                {
                    title: {
                        text: 'Clicks / Clicks Goals',
                    },
                },              
            ],            
            
            legend: {
                enabled: true,
            },              

            series: [
                {
                    name: 'Clicks',
                    type: 'column',
                    data: data.merged_clicks,     
                    
                    tooltip: {
                        valueDecimals: 0,
                    }
                },    
                {
                    name: 'ClicksGoals',
                    type: 'spline',
                    data: data.merged_clicks_goal,     
                    
                    tooltip: {
                        valueDecimals: 0,
                    }
                },  
            ],            
        });
    };    
    
    generateCompletesChart = function(categories, data) {
        Highcharts.chart('completes-container', {
            exporting: { enabled: false },
            credits: { enabled: false },
            chart: {
                type: 'column',
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,

                height: '250px',
            },
            title: {
                text: null,
            },
            xAxis: {
                categories: categories,
            },
            yAxis: [
                {
                    title: {
                        text: 'Delivered Completes',
                    },                    
                },              
            ],
            legend: {
                enabled: false,
            },            

            series: [
                {
                    name: 'Completes',
                    data: data.merged_completes,     
                    tooltip: {
                        valueDecimals: 0,
                    }
                },                     
            ],            
        });
    };
    
    generateCtrChart = function(categories, data) {
        Highcharts.chart('ctr-container', {
            exporting: { enabled: false },
            credits: { enabled: false },
            chart: {              
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,

                height: '250px',
            },
            title: {
                text: null,
            },
            xAxis: {
                categories: categories,
            },
            yAxis: [
                {
                    title: {
                        text: 'ctr',
                    },   
                    labels: {
                        format: "{value}%"
                    }
                },              
            ],
            legend: {
                enabled: false,
            },            

            series: [
                {
                    name: 'ctr',
                    data: data.ctr,      
                    tooltip: {
                        valueDecimals: 3,
                        valueSuffix: '%',
                    }
                },                     
            ],            
        });
    };
    
    generateVctrChart = function(categories, data) {
        Highcharts.chart('vctr-container', {
            exporting: { enabled: false },
            credits: { enabled: false },
            chart: {              
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,

                height: '250px',
            },
            title: {
                text: null,
            },
            xAxis: {
                categories: categories,
            },
            yAxis: [
                {
                    title: {
                        text: 'vctr',
                    }, 
                    labels: {
                        format: "{value}%"
                    }
                },              
            ],
            legend: {
                enabled: false,
            },            

            series: [
                {
                    name: 'vctr',
                    data: data.vctr, 
                    tooltip: {
                        valueDecimals: 3,
                        valueSuffix: '%',
                    }
                },                     
            ],            
        });
    };
})(window.angular);
